export default {
      id: "ic-misc-write-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-misc-write-usage",
      toString: function () {
        return this.url;
      }
    }